import { render, staticRenderFns } from "./folder-item-view-4-product-resource-view.vue?vue&type=template&id=3c5a1169&"
import script from "./folder-item-view-4-product-resource-view.vue?vue&type=script&lang=ts&"
export * from "./folder-item-view-4-product-resource-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports